import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { createNavigateToPathFunctions } from 'core/services/navigation/utils/navigateToPathFunctions';
import { createGetPathParamsFunctions } from 'core/services/navigation/utils/getPathParamsFunctions';
import { createPathFunctions } from 'core/services/navigation/utils/createPathFunctions';

export const pathsV2Creators = createPathFunctions;

export const usePathsV2 = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  return {
    navigateToPath: createNavigateToPathFunctions(navigate),
    getPathParams: createGetPathParamsFunctions(params),
    getSearchParams: (key: string) => searchParams.get(key)
  };
};
